import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import * as XLSX from "xlsx";
import { UserWalletService } from "../user-wallet.service";
@Component({
  selector: "app-user-deposits",
  templateUrl: "./user-deposits.component.html",
  styleUrls: ["./user-deposits.component.sass"],
})
export class UserDepositsComponent implements OnInit {
  constructor(
    private userWalletService: UserWalletService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.getDepositeTransactions(this.itemsPerPage);
  }

  // transactionData:any;
  data: [];
  depositesTransactions: any;
  itemsPerPage: number = 6;
  totalItems: any;
  page: number = 0;
  userName: any;
  getDepositeTransactions(itemPerPage) {
    this.spinner.show();
    let Data = {
      // "driverId":this.id,
      page: 0,
      perPage: itemPerPage,
    };
    // console.log("Data",Data)
    this.userWalletService.userDeposite(Data).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.depositesTransactions = result.data;
        this.totalItems = result.totalRecords;
        console.log("Deposite Transaction Data", this.depositesTransactions);
      } else {
        this.toaster.error(result.message);
      }
    });
  }

  gty(page) {
    this.spinner.show();
    let Data = {
      // "driverId":this.id,
      page: this.page - 1,
      perPage: this.itemsPerPage,
    };
    // console.log("Data",Data)
    this.userWalletService.userDeposite(Data).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.depositesTransactions = result.data;
        // console.log("Deposite Transaction Data",this.depositesTransactions)
      } else {
        this.toaster.error(result.message);
      }
    });
  }

  allDepositeTransactionData: any;
  getAllDepositeTransactionData() {
    this.spinner.show();
    let Data = {
      // "driverId":this.id,
      page: 0,
      perPage: this.totalItems,
    };
    // console.log("Data",Data)
    this.userWalletService.userDeposite(Data).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        // console.log("All Deposite Transaction Data",result.data)
        this.allDepositeTransactionData = result.data;
        this.exportAllToExcel(this.allDepositeTransactionData);
      } else {
        this.toaster.error(result.message);
      }
    });
  }

  // Export To Excel
  exportTableToExcel(fileName: string): void {
    // console.log("function called")
    const tableElement = document.getElementById("depositeTransactionTable");
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(tableElement);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

  exportAllToExcel(array) {
    // console.log("Export Excel All Data",array)
    const data = array.map((item) => ({
      UserId: item.userId,
      UserName: item.userName,
      MobileNumber: item.phoneNumber,
      PaymentOrderID: item.paymentOrderId,
      Amount: item.amount,
      Status: item.status,
      Reason: item.reason,
      CreatedON: new Date(item.timestamp * 1000).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "User_Deposit_Transactions.xlsx");
  }
}
